// Module
var code = "<p class=\"ib-text ib-text--color-light\">{{popoverCtrl.text|translate}}</p>\n<button class=\"popover-close icon-cerrar\" type=\"button\" data-ng-click=\"popoverCtrl.close()\">\n    <span class=\"u-hide-accessible\">{{'POP_OVER_ACCESSIBILITY_CLOSE'|translate}}</span>\n</button>";
// Exports
module.exports = code;